/**
 * Mattress bundle cart: lock foundation/accessory qty & remove;
 * sync all bundle line quantities when parent (mattress) changes.
 */
(function () {
  'use strict';

  function refreshBundleLines() {
    const el = document.getElementById('sc-bundle-cart-data');
    if (!el) {
      window.scBundleCartLines = [];
      return;
    }
    try {
      window.scBundleCartLines = JSON.parse(el.textContent);
    } catch (e) {
      window.scBundleCartLines = [];
    }
  }

  function getLineProperty(item, name) {
    if (!item || !item.properties) return '';
    const val = item.properties[name];
    if (val == null) return '';
    return String(val).trim();
  }

  function isCartLineChild(item) {
    if (!item) return false;
    if (getLineProperty(item, '_bundle_locked') === '1') return true;
    if (getLineProperty(item, 'Linked to') && getLineProperty(item, '_bundle_group_id')) return true;
    return false;
  }

  function isCartLineParent(item) {
    if (!item || isCartLineChild(item)) return false;
    if (getLineProperty(item, '_bundle_parent') === '1') return true;
    if (getLineProperty(item, '_bundle_group_id')) return true;
    return false;
  }

  function getLineMeta(lineNumber) {
    const lines = window.scBundleCartLines || [];
    return lines.find((l) => l.line === Number(lineNumber));
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error('Cart unavailable');
    return res.json();
  }

  function getBundleItemsFromCart(cart, groupId) {
    if (!cart || !cart.items || !groupId) return [];
    return cart.items.filter((item) => getLineProperty(item, '_bundle_group_id') === groupId);
  }

  function findParentLineNumber(cart, groupId) {
    const bundleItems = getBundleItemsFromCart(cart, groupId);
    const parentItem = bundleItems.find((item) => isCartLineParent(item));
    if (!parentItem) return null;
    const idx = cart.items.findIndex((item) => item.key === parentItem.key);
    return idx >= 0 ? idx + 1 : null;
  }

  function applyCartSections(cartItemsEl, parsedState, line, quantity, event, name, variantId) {
    const quantityElement =
      document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
    const items = document.querySelectorAll('.cart-item');

    if (parsedState.errors) {
      if (quantityElement) {
        quantityElement.value = quantityElement.getAttribute('value');
        cartItemsEl.updateLiveRegions(line, parsedState.errors);
      }
      return;
    }

    cartItemsEl.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    cartItemsEl.getSectionsToRender().forEach((section) => {
      const root = document.getElementById(section.id);
      if (!root) return;
      const elementToReplace = root.querySelector(section.selector) || root;
      if (parsedState.sections && parsedState.sections[section.section]) {
        elementToReplace.innerHTML = cartItemsEl.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      }
    });

    refreshBundleLines();

    if (quantityElement) {
      const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
      let message = '';
      if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value, 10)) {
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
      }
      cartItemsEl.updateLiveRegions(line, message);
    }

    const lineItem =
      document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem && name && lineItem.querySelector(`[name="${name}"]`)) {
      if (cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`));
      } else {
        lineItem.querySelector(`[name="${name}"]`).focus();
      }
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
    } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
    }
  }

  async function updateBundleGroupQuantity(cartItemsEl, parentLine, quantity, event, name, variantId) {
    const lineNum = parseInt(parentLine, 10);
    let groupId = null;

    const meta = getLineMeta(lineNum);
    if (meta && meta.groupId) {
      groupId = meta.groupId;
    }

    let cart;
    try {
      cart = await fetchCart();
    } catch (e) {
      console.error('[cart-bundle-sync] Could not load cart', e);
      return;
    }

    if (!groupId) {
      const clicked = cart.items[lineNum - 1];
      if (clicked) groupId = getLineProperty(clicked, '_bundle_group_id');
    }

    const bundleItems = getBundleItemsFromCart(cart, groupId);
    if (!bundleItems.length) {
      return;
    }

    const displayLine = findParentLineNumber(cart, groupId) || lineNum;

    const updatesByLine = {};
    const keysInGroup = [];
    cart.items.forEach((item, index) => {
      if (getLineProperty(item, '_bundle_group_id') !== groupId) return;
      updatesByLine[String(index + 1)] = quantity;
      if (item.key) keysInGroup.push(item.key);
    });

    if (!Object.keys(updatesByLine).length) {
      return;
    }

    cartItemsEl.enableLoading(displayLine);

    const sections = cartItemsEl.getSectionsToRender().map((section) => section.section);
    const sectionsUrl = window.location.pathname;
    const eventTarget = quantity === 0 ? 'clear' : 'change';

    async function requestCartUpdate(updatesPayload) {
      const body = JSON.stringify({
        updates: updatesPayload,
        sections: sections,
        sections_url: sectionsUrl,
      });
      const response = await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      const state = await response.text();
      return JSON.parse(state);
    }

    async function requestChangesByKey() {
      let lastState = null;
      for (let i = 0; i < keysInGroup.length; i++) {
        const payload = {
          id: keysInGroup[i],
          quantity: quantity,
        };
        if (i === keysInGroup.length - 1) {
          payload.sections = sections;
          payload.sections_url = sectionsUrl;
        }
        const response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body: JSON.stringify(payload) } });
        const state = await response.text();
        lastState = JSON.parse(state);
      }
      return lastState;
    }

    try {
      let parsedState = await requestCartUpdate(updatesByLine);

      if (parsedState.errors || !parsedState.sections) {
        parsedState = await requestChangesByKey();
      }

      if (parsedState.errors) {
        cartItemsEl.updateLiveRegions(displayLine, parsedState.errors);
        return;
      }

      applyCartSections(cartItemsEl, parsedState, displayLine, quantity, event, name, variantId);

      if (typeof CartPerformance !== 'undefined' && event) {
        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);
      }
    } catch (e) {
      console.error('[cart-bundle-sync] Bundle update failed', e);
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = window.cartStrings.error;
    } finally {
      cartItemsEl.disableLoading(displayLine);
    }
  }

  function quantityElementForLine(line) {
    return document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
  }

  async function resolveBundleActionFromCart(lineNum) {
    refreshBundleLines();
    const meta = getLineMeta(lineNum);

    if (meta && meta.isChild) {
      return { type: 'blocked-child' };
    }

    let cart;
    try {
      cart = await fetchCart();
    } catch (e) {
      if (meta && meta.isParent && meta.groupId) {
        return { type: 'bundle-parent', groupId: meta.groupId };
      }
      return { type: 'default' };
    }

    const item = cart.items[lineNum - 1];
    if (!item) return { type: 'default' };

    if (isCartLineChild(item)) {
      return { type: 'blocked-child' };
    }

    const groupId = getLineProperty(item, '_bundle_group_id');
    if (!groupId) return { type: 'default' };

    if (isCartLineParent(item)) {
      return { type: 'bundle-parent', groupId: groupId };
    }

    const bundleItems = getBundleItemsFromCart(cart, groupId);
    const parentItem = bundleItems.find((row) => isCartLineParent(row));
    if (parentItem && parentItem.key === item.key) {
      return { type: 'bundle-parent', groupId: groupId };
    }

    return { type: 'default' };
  }

  function patchCartItems() {
    const CartItemsClass = customElements.get('cart-items');
    if (!CartItemsClass || CartItemsClass.prototype.__scBundlePatched) return;

    const originalUpdateQuantity = CartItemsClass.prototype.updateQuantity;

    CartItemsClass.prototype.updateQuantity = function (line, quantity, event, name, variantId) {
      const lineNum = parseInt(line, 10);
      const qty = parseInt(quantity, 10);
      const cartItemsEl = this;

      resolveBundleActionFromCart(lineNum).then((action) => {
        if (action.type === 'blocked-child') {
          cartItemsEl.resetQuantityInput(line);
          return;
        }

        if (action.type === 'bundle-parent') {
          if (isNaN(qty) || qty < 0) {
            cartItemsEl.resetQuantityInput(line);
            return;
          }
          updateBundleGroupQuantity(cartItemsEl, lineNum, qty, event, name, variantId);
          return;
        }

        originalUpdateQuantity.call(cartItemsEl, line, quantity, event, name, variantId);
      });
    };

    CartItemsClass.prototype.__scBundlePatched = true;
  }

  function init() {
    refreshBundleLines();
    patchCartItems();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        refreshBundleLines();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
